<template>
    <v-container
        fluid
        fill-height
        class="background"
    >
        <v-row>
            <v-col>
                <v-row justify="end">
                    <v-card
                        width="520px"
                        height="650px"
                        align="center"
                        style="border-radius:30px;"
                        class="mr-5"
                        >
                        <v-card-text class="font-type-title">
                            Miguel y su compañero
                        </v-card-text>
                        <v-card-text class="font-type-text">
                            Miguel es un niño de 6 años. Su fiel compañero es un perro llamado Pancho.
                            Los dos juegan juntos en el patio de la casa. Son los mejores amigos desde
                            que se conocieron.
                        </v-card-text>
                    </v-card>
                </v-row>
            </v-col>
            <v-col>
                <v-row justify="start">
                    <v-card
                        width="520"
                        height="650"
                        align="center"
                        style="border-radius:30px;"
                        class="ml-5"
                        >
                        Hola
                    </v-card>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

</template>
<script>
export default {

}
</script>
<style scoped>
    .background {
        background-color:  #FDF5E6;
        min-height: 100vh;
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        padding: 0px;
    }
    .font-type-title{
        font-size: 34px;
        font-weight: 700;
        line-height: 39px;
        letter-spacing: 0px;
        margin-top: 180px;

    }
    .font-type-text {
        font-size: 26px;
        font-weight: 700;
        line-height: 30px;
        letter-spacing: 0px;
        text-align: left;
        margin-left: 80px;
        margin-right: 80px;
        max-width: 360px;
    }
</style>
